import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/punto-de-venta/configuraciones/facturacion',
  documento: 'pos-settings',
  acceso: 'sesion',
  filas: ['017'],
  cita: 'Areas/POS_Settings/Controllers/SettingsController.cs:137',
} satisfies RutaProd;
